// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__13xTf","empty":"ModalGraph_empty__3AnA5"};